import { Input as AntdInput } from 'antd'
import type { TextAreaProps } from 'antd/es/input'
import styled from 'styled-components'

const { TextArea: AntdTextArea } = AntdInput

const TextAreaStyled = styled(AntdTextArea)`
  input {
    height: 32px;
  }
`

const TextArea = (props: TextAreaProps) => <TextAreaStyled {...props} />

export default TextArea
